export interface IExternalComponentOptions {
    /**
     * The width of the external component
     */
    width?: number;
    /**
     * The height of the external component
     */
    height?: number;
}
